<template>
  <div class="documentList" v-loading="payLogin">
    <div style="background: #ffffff">
      <ul class="documentNav inner">
        <li class="navItem" v-for="(item,index) in navList" :class="type == item.name?'active':''"
            @click="changeType(item)">{{item.title}}
        </li>
      </ul>
    </div>
    <div class="documentContent">
      <div class="inner">
        <div class="documentInner" v-if="showWss == 'list'">
          <div class="screenTop">
            <p class="title">{{title}}</p>
            <div class="screenContent">
              <span class="name">文档名称</span>
              <el-input v-model="namee" class="screenInput" placeholder="文档名称"></el-input>
              <span class="name">签署方</span>
              <el-input v-model="signer" class="screenInput" placeholder="签署方"></el-input>
              <span class="name">发送时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <!--<el-date-picker
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>-->
              <el-button class="button" @click="search">搜索</el-button>
              <el-button type="warning" class="button" style="margin-left: 30px" @click="re">重置</el-button>
            </div>
          </div>
          <div class="documentListContent">
            <ul class="list">
              <li class="item" v-for="(item,index) in list" v-if="list.length>0">
                <div class="itemLeft">
                  <div class="topWarp">
                    <span class="title">{{item.name}}</span>
                    <span class="lookDetail" @click="showDetail(item)">查看详情</span>
                  </div>
                  <div class="itemBottom">
                    <div class="se">发起人：{{item.creater}}</div>
                    <div class="se">签署方：{{item.singer}}</div>
                    <div class="se">时间：{{item.sendTime}}</div>
                  </div>
                </div>
                <div class="itemRight" v-if="type==5">
                  <el-button type="primary" class="button" @click="qs(item.id)">签署</el-button>
                  <el-button class="button" @click="jq(item.id)">拒签</el-button>
                </div>
                <div class="itemRight" v-if="type==2">
                  <div class="isOverBtn" @click="down(item.id)">文档下载</div>
                </div>
                <div class="itemRight" v-if="type==0">
                  <el-button type="primary" plain class="button" @click="edit(item.id)">编辑</el-button>
                  <el-button type="warning" plain class="button" @click="del(item.id)">删除</el-button>
                </div>
                <div class="itemRight" v-if="type==6">
                  <el-button type="primary" plain class="button" @click="pay(item.id)">支付</el-button>
                </div>
                <div class="itemRight" v-if="type==3">
                  <span class="refuse">已拒签</span>
                </div>
              </li>
              <li class="item" v-if="list.length==0" style="font-size: 15px;text-align: center">暂无合同</li>
            </ul>

            <el-pagination
              v-show="list.length>0"
              @current-change="handleCurrentChange"
              :page-size="20"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
        <div class="documentDetail" v-if="showWss =='detailsss'">
          <div class="dh">
            <span class="cc">文档</span><i class="cc">/</i><span class="cc">{{title}}</span><i>/</i><span>文档详情</span>
          </div>
          <div class="detailContent">
            <div class="title">文档详情</div>
            <div class="content">
              <p class="companyName">{{details.contractName}} </p>
              <div class="infoWarp">
                <p class="sponsorName">
                  <span class="tttt1">签署状态：</span>
                  {{title}}
                </p>
                <p class="sponsorName">
                  <span class="tttt1">发起方：</span>
                  {{details.creater}}
                </p>
                <p class="sponsorName">
                  <span class="tttt1">发起时间：</span>
                  {{details.sendTime}}
                </p>
                <p class="sponsorName" @click="down(details.contractId)">
                  <span class="tttt1">文件下载：</span>
                  <span class="sm">《{{details.contractName}}》 <i>立即下载</i></span>
                </p>
              </div>
              <div class="sponsor">
                <p class="name">签署方</p>
                <el-table
                  :data="details.apiSignUserList"
                  border
                  class="tableWarp" style="text-align: center">
                  <el-table-column
                    label="姓名/企业姓名">
                    <template slot-scope="scope">
                      <!---->
                      <span style="font-size: 12px;color: #68B757;">{{scope.row.username.split('/')[0]}}</span>
                      <span v-if="scope.row.username.split('/')[1]" style="font-size: 12px;color: #68B757;"><br>{{scope.row.username.split('/')[1]}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="phone"
                    label="手机号码"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="code"
                    label="身份证号码/统一社会信用代码"
                    width="230">
                  </el-table-column>
                  <el-table-column
                    prop="mail"
                    label="电子邮箱">
                  </el-table-column>
                  <el-table-column
                    prop="signTime"
                    label="签署时间">
                  </el-table-column>
                  <el-table-column
                    label="状态">
                    <template slot-scope="scope">
                      <span v-show="scope.row.status==1" style="font-size: 12px;color: #68B757;">已签署</span>
                      <span v-show="scope.row.status==0" style="font-size: 12px;color:red;">未签署</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="btns" v-if="details.sendStatus == 5">
              <el-button class="button" style="margin-right: 30px;" type="primary" @click="qs(details.contractId)">签署</el-button>
              <el-button class="button" @click="jq(details.contractId)">拒签</el-button>
            </div>
            <div class="btns" v-if="details.sendStatus == 0">
              <el-button class="button" style="margin-right: 30px;" type="primary" @click="edit(details.contractId)">
                编辑
              </el-button>
              <el-button class="button" @click="del(details.contractId)">删除</el-button>
            </div>
            <div class="btns" v-if="details.sendStatus == 6">
              <el-button class="button" style="margin-right: 30px;" type="primary" @click="pay(details.contractId)">支付
              </el-button>
            </div>
            <div class="btns" v-if="details.sendStatus == 2">
              <el-button class="button" style="margin-right: 30px;" type="primary" @click="down(details.contractId)">
                文档下载
              </el-button>
            </div>
            <div class="btns" v-if="details.sendStatus == 3">
              <span class="isOver">已拒签</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tc" v-show="hasNum || imgPay">
      <div class="innerBox">
        <p class="title">支付信息<span class="closeBtn" @click="close"></span></p>
        <div class="content1" v-show="hasNum">
          {{payTxt}}
        </div>
        <div class="content2" v-show="imgPay">
          您当前账户剩余可签署文档份数为0,<br>
          本次签署支付费用 <i style="font-size: 14px;color: #D8662C">10.00</i>元<br>
          请扫描二维码进行支付。
          <img :src="payImg"style="display: block;margin: 0 auto;margin-top: 30px;">
        </div>
        <div class="tcBottom">
          <div class="btn" @click="payOver">完成</div>
        </div>
      </div>
    </div>
    <div v-html="payText"></div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {mapActions, mapGetters} from 'vuex'

  export default {
    data() {
      return {
        payLogin:false,
        navList: [
          {title: '待我签署', name: 5},
          {title: '待他人签署', name: 4},
          {title: '已完成', name: 2},
          {title: '草稿', name: 0},
          {title: '已拒签', name: 3},
          {title: '待支付', name: 6},
        ],
        showWss: 'list',
        signer: '',
        namee: '',
        date: ["", ""],
        total: 123,
        type: 5,
        title: '',
        tableData: [],
        list: [],
        nowPage: 0,
        details: {},
        hasNum: false,
        imgPay: false,
        payImg:'',
        payTxt:'',
        payText:''
      }
    },
    created() {
      this.type = this.$route.params.type;
      let _this = this;
      this.navList.forEach((ite, ind) => {
        if (ite.name == _this.type) {
          _this.title = ite.title
        }
      })
      this.getData(true);
    },
    computed: {
      ...mapGetters([
        "gUserInfo"
      ])
    },
    methods: {
      ...mapActions([
        "aUserInfo"
      ]),
      payOver(){
        this.hasNum = false;this.imgPay = false;
        this.getData(true);
      },
      pay(id) {
        let _this = this;
        _this.payLogin = true;
        _this.ajpost('/api/contract/sendContract', {contractId: id}, function (datas) {
          if (datas.data.code == 0) {
            _this.payLogin = false;
            _this.payTxt = datas.data.data;
            _this.hasNum = true;
          } else {
            _this.showIsPayFinished()
            _this.payLogin = false;
            window.open('/pay?orderNo=' + datas.data.msg, '_blank');
          }
        });
      },
      showIsPayFinished() {
        this.$confirm('您是否已经完成支付?', '提示', {
          confirmButtonText: '已完成支付',
          cancelButtonText: '支付遇到问题',
          type: 'info'
        }).then(() => {
          window.location.reload()
        }).catch(() => {
        })
      },
      close() {
        this.hasNum = false;
        this.imgPay = false;
        this.getData(true)
      },
      search() {
        this.getData(true)
      },
      showDetail(item) {
        let _this = this;
        _this.ajpost('/api/contract/findContractInfo', {id: item.id}, function (data) {
          let flag = true
          data.data.apiSignUserList.map((item)=>{
            console.log(item)
            if(item.status == 0){
              flag = false
            }
          })
          flag?data.data.detailStatus = flag:data.data.detailStatus = false
          _this.details = data.data;
          _this.showWss = 'detailsss'
        })
      },
      handleCurrentChange(v) {
      },
      edit(id) {
        this.$router.push('/fire/edit/' + id)
      },
      re() {
        let _this = this;
        _this.date = ["", ""];
        _this.namee = '';
        _this.signer = '';
        this.getData(true)
      },
      jq(id) {
        let _this = this;
        this.$confirm('您确认要拒签这份合同吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.ajpost('/api/contract/addContractRefuse', {id: id}, function (data) {
            if (data.code != 0) {
              this.$message({
                message: data.msg,
                type: 'warning'
              });
            } else {
              _this.$message({
                type: 'success',
                message: '拒签成功!'
              });
              _this.showWss = 'list';
              _this.getData()
            }
          })
        }).catch(() => {
        });
      },
      del(id) {
        let _this = this;
        this.$confirm('您确认要删除这份合同吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.ajpost('/api/contract/deleteContract',
            {
              "id": id
            }, function (data) {
              if (data.code != 0) {
                _this.$message({
                  message: data.msg,
                  type: 'warning'
                });
              } else {
                _this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                _this.showWss = 'list';
                _this.getData();
              }
            })
        }).catch(() => {
        });
      },
      changeType(type) {
        this.type = type.name;
        this.title = type.title;
        this.showWss = 'list';
        this.getData(true);
        this.$router.push(`/documentList/${type.name}`)

      },
      down(id) {
        let _this = this;
        console.log(id)
        _this.ajpost('/api/contract/downContract', {id: id}, function (data) {
          let newTab = window.open('about:blank');
          console.log(data)
          newTab.location.href = data.data.data;
        })
      },
      qs(id){
        this.$router.push('/fire/qs/' + id)
      },
      getData(isRegest) {
        let _this = this;
        if (isRegest) {
          _this.nowPage = 0;
        }
        let obj = {
          "form_data": {
            "endTime":_this.date[1],
            "name": _this.namee,
            "signer": _this.signer,
            "startTime":_this.date[0],
            "type": _this.type
          },
          "page_data": {
            "current_page": _this.nowPage,
            "page_size": 20
          }
        };
        _this.ajpost('/api/contract/findLoadMeSignList', obj, function (data) {
          _this.list = data.data.list;
          _this.total = data.data.total;
        },function (err) {
          console.log(err)
        })
      }
    }
  }
</script>
<style>
  @import "../../../assets/less/documentList.css";
</style>



// WEBPACK FOOTER //
// src/components/home/documentList/documentList.vue